/**
 * Combine all reducers in this file and export the combined reducers.
 */
//  Externals
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
//  Internals
import { InjectedReducersType } from 'utils/types/injector-typings';

// Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['entities', 'userData', 'masterData', 'statusList'], // Persist these reducers
};

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
const createReducer = (injectedReducers: InjectedReducersType = {}) => {
  const rootReducer = combineReducers({
    // Add a placeholder reducer to ensure store is initialized properly
    _persist: (state = {}) => state,
    ...injectedReducers,
  });

  // Always wrap with persist reducer
  return persistReducer(persistConfig, rootReducer);
};

export default createReducer;
